<template>
  <div>
    <Card
      style="margin-top: 20px"
      :style="{
        backgroundImage: `url(${getWaterMarkStatus})`
      }"
    >
      <Table
        border
        stripe
        ref="table"
        :loading="loading"
        :columns="columns"
        :data="data"
        highlight-row
        @on-row-click="rowClick"
      >
      </Table>
      <Row style="margin-top:15px">
        <Col span="19">
          <Page
            :total="total"
            :page-size="pageInfo.pageSize"
            @on-change="pageChange"
          />
        </Col>
      </Row>
    </Card>
    <Card
      style="margin-top: 20px"
      :style="{
        backgroundImage: `url(${getWaterMarkStatus})`
      }"
    >
      <p slot="title">工作经验信息</p>
      <Form
        style="margin: 30px 20px"
        :model="formItem"
        inline
        :label-width="150"
        label-position="left"
        :disabled="disableSelfData.WorkExperience"
        v-if="showSelfData.WorkExperience == '1'"
      >
        <FormItem
          :label="lang == 'zh' ? chNameMap[val] : enNameMap[val]"
          v-for="(val, key) in sortfMap"
          :key="val"
          style="margin-right: 50px;"
          v-if="showSelfData[val] == '1'"
        >
          <DatePicker
            v-if="val == 'startdate' || val == 'enddate'"
            type="date"
            v-model="formItem[val]"
            style="min-width: 260px"
            :disabled="disableSelfData[val] == 0"
          ></DatePicker>
          <Select
            v-else-if="val == 'e_title'"
            :clearable="true"
            v-model="formItem[val]"
            style="min-width: 260px;"
            :disabled="disableSelfData[val] == 0"
          >
            <Option
              v-for="item in positionList"
              :value="item.code"
              :key="item.code"
              :label="item.name"
            ></Option>
          </Select>
          <Input
            v-else-if="val == 'jobdescription' || val == 'comment'"
            type="textarea"
            v-model="formItem[val]"
            style="min-width: 260px"
            :disabled="disableSelfData[val] == 0"
          />
          <Input
            v-else
            v-model="formItem[val]"
            style="min-width: 260px;"
            :disabled="disableSelfData[val] == 0"
          />
        </FormItem>
      </Form>
    </Card>
    <div class="bottomBtn">
      <Button
        type="primary"
        @click="saveData()"
        :disabled="disableSelfData.WorkExperience"
        >保存</Button
      >
      <Button v-if="plan" @click="returnPage()" style="margin-left: 15px"
        >返回</Button
      >
    </div>
  </div>
</template>

<script>
import axios from "axios";
import DateUtil from "../../../../../src/util/DateUtil";
import watermark from "@/util/watermark";

export default {
  data() {
    return {
      date: new DateUtil(),
      formItem: {
        e_employername: ""
      },
      positionList: [],
      data: [],
      pageInfo: {
        itemCount: 0,
        pageNo: 1,
        pageSize: 10
      },
      total: 1,
      loading: false,
      disableSelfData: {},
      showSelfData: {},
      chNameMap: {},
      enNameMap: {},
      id: null,
      plan: null,
      userId: "",
      sortfMap: {}
    };
  },
  computed: {
    //国际化监听
    lang() {
      return this.$store.getters.selectLangeData;
    },
    getWaterMarkStatus() {
      return this.$store.getters.getWaterMarkStatus == 1
        ? watermark.addWaterMark()
        : "";
    },
    columns() {
      let column = [
        {
          title:
            this.lang == "zh"
              ? this.chNameMap.startdate
              : this.enNameMap.startdate,
          key: "startdate",
          align: "center",
          minWidth: 230,
          render: (h, params) => {
            return h(
              "span",
              this.date.dateVal(params.row.startdate, "YYYY/MM/DD")
            );
          }
        },
        {
          title:
            this.lang == "zh" ? this.chNameMap.enddate : this.enNameMap.enddate,
          key: "enddate",
          align: "center",
          minWidth: 230,
          render: (h, params) => {
            return h(
              "span",
              this.date.dateVal(params.row.enddate, "YYYY/MM/DD")
            );
          }
        },
        {
          title:
            this.lang == "zh" ? this.chNameMap.salary : this.enNameMap.salary,
          key: "salary",
          align: "center",
          minWidth: 230
        },
        {
          title:
            this.lang == "zh" ? this.chNameMap.e_title : this.enNameMap.e_title,
          key: "eTitle",
          align: "center",
          minWidth: 230,
          render: (h, params) => {
            var position = "";
            this.positionList
              ? this.positionList.forEach((item, index) => {
                  if (item.code == params.row.eTitle) {
                    position = item.name;
                  }
                })
              : "";
            return h("span", position);
          }
        },
        {
          title:
            this.lang == "zh"
              ? this.chNameMap.guaranteeperson
              : this.enNameMap.guaranteeperson,
          key: "guaranteeperson",
          align: "center",
          minWidth: 230
        },
        {
          title:
            this.lang == "zh"
              ? this.chNameMap.leavereason
              : this.enNameMap.leavereason,
          key: "leavereason",
          align: "center",
          minWidth: 230
        },
        {
          title:
            this.lang == "zh"
              ? this.chNameMap.duration
              : this.enNameMap.duration,
          key: "duration",
          align: "center",
          minWidth: 230
        }
      ];
      let arr = [];
      arr = column.filter(item => {
        return this.showSelfData[item.key] == 1;
      });
      return arr;
    }
  },
  created() {
    let userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    this.userId = userInfo.serialnumber;
  },
  methods: {
    getData(id, plan) {
      this.plan = plan ? plan : "";
      this.id = id;
      this.getTableData();
    },
    getTableData() {
      let obj = {
        sheetId: this.id,
        serialnumber: this.plan ? this.plan : this.userId,
        bePersonal: this.plan ? "0" : "1",
        pageNo: this.pageInfo.pageNo,
        pageSize: this.pageInfo.pageSize
      };
      this.loading = true;
      axios
        .post("/WorkExperience/researchWorkExperienceInfo", obj)
        .then(res => {
          this.loading = false;
          if (res) {
            this.data = res.data;
            this.total = Number(res.pageInfo.total);
            this.showSelfData = res.showSelfData;
            this.disableSelfData = res.disableSelfData;
            this.chNameMap = res.chNameMap;
            this.enNameMap = res.enNameMap;
            this.sortfMap = res.sortfMap;
            delete this.sortfMap[8];
            this.disableSelfData.WorkExperience =
              this.disableSelfData.WorkExperience == 0 ? true : false;
            if (res.optionData) {
              this.positionList = res.optionData.ETITLE;
            }
          }
        });
    },
    pageChange(val) {
      this.pageInfo.pageNo = val;
      this.getTableData();
    },
    rowClick(row, index) {
      this.formItem = row;
    },
    saveData() {
      this.$Modal.confirm({
        title: this.$notice("sureSave"),
        content: "",
        onOk: () => {
          this.formItem.eTitle = this.formItem.eTitle;
          let obj = {
            serialnumber: this.plan,
            ...this.formItem
          };
          axios
            .post("/WorkExperience/rollBackWorkExperienceInfo", obj)
            .then(res => {
              if (res) {
                this.getTableData();
                this.$Message.info(res);
                this.formItem = {};
              }
            });
        },
        onCancel: () => {}
      });
    },
    returnPage() {
      this.$router.back();
    }
  }
};
</script>

<style scoped>
.formRow {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.formCol {
  width: calc((100% - 210px) / 3);
  float: left;
  /* margin-right: 30px; */
}
@media screen and (max-width: 1300px) and (min-width: 800px) {
  .formCol {
    width: calc((100% - 40px) / 2);
  }
}
@media screen and (max-width: 800px) {
  .formCol {
    width: 100%;
  }
}
.bottomBtn {
  margin-top: 20px;
  display: flex;
  justify-content: center;
}
.ivu-date-picker {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/process/MyQuery/components/WorkExperience.vue